import { Component, OnInit, Inject } from '@angular/core';
import { MatChipInputEvent, MatSnackBar } from '@angular/material';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSortModule, MatSort } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { formatDate } from '@angular/common';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-create-criterio',
	templateUrl: './create-criterio.component.html',
	styleUrls: ['./create-criterio.component.scss']
})
export class CreateCriterioComponent implements OnInit {

	Criterio_DATA = [];
	visible = true;
	selectable = true;
	removable = true;
	addOnBlur = true;
	correos: any[] = [];
	columnas = [];
	readonly separatorKeysCodes: number[] = [ENTER, COMMA];
	alarmaColumns: any = ['CRITERIO', 'CONDICION', 'VALOR', 'ACCION'];
	dataSource = new MatTableDataSource<any>(this.Criterio_DATA);
	condiciones = [
		{ VALOR: 1, TEXTO: '<' },
		{ VALOR: 2, TEXTO: '<=' },
		{ VALOR: 3, TEXTO: '==' },
		{ VALOR: 4, TEXTO: '>' },
		{ VALOR: 5, TEXTO: '>=' }
	];

	tipoValor = '';

	constructor(
		private gateway: GatewayService,
		private snackbar: MatSnackBar,
		@Inject(MAT_DIALOG_DATA) private data,
		private spinner: NgxSpinnerService,
		private dialogRef: MatDialogRef<CreateCriterioComponent>,
		private localSave: LocalSaveService,
		private tabController: ComponentTabController
	) { }

	ngOnInit() {
		this.getColumnas();
		this.getCriterios();
	}

	getColumnas() {
		this.gateway.get('listacolumnas', {}).then((result:any) => {
			// console.log(result.rows);
			this.columnas = result.rows;
		}
		).catch(function (e) {
		});
	}

	getCriterios() {
		this.gateway.get('obtenercriterios', { IDCAMPANA: this.localSave.get('campana') }).then((result:any) => {
			// console.log(result.rows);
			result.rows.forEach(element => {
				let obj = {
					CRITERIO: { idcatalogocolumna: element.idcatalogocolumna, nombre: element.nombre },
					CONDICION: this.generarCondicion(element.condicion),
					VALOR: element.valor
				}
				this.Criterio_DATA.push(obj);
			});
			this.dataSource = new MatTableDataSource<any>(this.Criterio_DATA);
			// console.log(this.Criterio_DATA)
		}
		).catch(function (e) {
		});
	}

	onNoClick() {
		this.localSave.delete('campana');
		this.dialogRef.close();
	}

	generarCondicion(valor) {
		let cond = { VALOR: valor, TEXTO: '' }
		if (valor == 1) {
			cond.TEXTO = '<';
		} else if (valor == 2) {
			cond.TEXTO = '<=';
		} else if (valor == 3) {
			cond.TEXTO = '==';
		} else if (valor == 4) {
			cond.TEXTO = '>';
		} else if (valor == 5) {
			cond.TEXTO = '>=';
		}

		return cond;
	}

	deleteCriterio(element) {
		this.Criterio_DATA.forEach((item, index) => {
			if (item.CRITERIO.NOMBRE === element.CRITERIO.NOMBRE && item.CONDICION === element.CONDICION) this.Criterio_DATA.splice(index, 1);
		});
		this.dataSource = new MatTableDataSource(this.Criterio_DATA);
	}

	grupoVal = new FormGroup({
		criterio: new FormControl('', Validators.required),
		condicion: new FormControl('', Validators.required),
		valor: new FormControl('', Validators.required),
	});

	formatDate(date) {
		const d = new Date(date);
		let month = '' + (d.getMonth() + 1);
		let day = '' + d.getDate();
		const year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		return [day, month, year].join('/');
	}

	addCriterio() {
		let nuevo = {
			CRITERIO: this.grupoVal.controls.criterio.value,
			CONDICION: this.grupoVal.controls.condicion.value,
			VALOR: (this.tipoValor == 'fecha') ? this.formatDate(this.grupoVal.controls.valor.value) : this.grupoVal.controls.valor.value
		}
		if (this.Criterio_DATA.find(element => { return nuevo.CRITERIO.nombre === element.CRITERIO.nombre && nuevo.CONDICION.valor === element.CONDICION.valor })) {
			this.snackbar.open('Ya tiene asignado el criterio', '', {
				duration: 3000,
			});
			return;
		} else {
			this.Criterio_DATA.push(nuevo);
			this.dataSource = new MatTableDataSource<any>(this.Criterio_DATA);
		}

	}

	cambioColumna() {
		// console.log(this.grupoVal.controls.criterio.value)
		if (this.grupoVal.controls.criterio.value.TIPO == 0) {
			// Es texto
			this.condiciones = [{ VALOR: 3, TEXTO: '==' }];
			this.tipoValor = 'texto';
			this.grupoVal.controls.valor.setValidators([Validators.required, Validators.pattern('(?=.*?[A-Za-z ñÑáéíóúÁÉÍÓÚ]).+'), Validators.maxLength(20)]);
		} else if (this.grupoVal.controls.criterio.value.TIPO == 1) {
			// Es numero
			this.tipoValor = 'número';
			this.condiciones = [
				{ VALOR: 1, TEXTO: '<' },
				{ VALOR: 2, TEXTO: '<=' },
				{ VALOR: 3, TEXTO: '==' },
				{ VALOR: 4, TEXTO: '>' },
				{ VALOR: 5, TEXTO: '>=' },
			];
			this.grupoVal.controls.valor.setValidators([Validators.required, Validators.pattern('(-)?[0-9]+'), Validators.maxLength(20)]);
		} else if (this.grupoVal.controls.criterio.value.TIPO == 3) {
			// Es número no negativo
			this.tipoValor = 'número positivo';
			this.condiciones = [
				{ VALOR: 1, TEXTO: '<' },
				{ VALOR: 2, TEXTO: '<=' },
				{ VALOR: 3, TEXTO: '==' },
				{ VALOR: 4, TEXTO: '>' },
				{ VALOR: 5, TEXTO: '>=' },
			];
			this.grupoVal.controls.valor.setValidators([Validators.required, Validators.pattern('[0-9]+'), Validators.maxLength(20)]);
		} else if (this.grupoVal.controls.criterio.value.TIPO == 4) {
			// Es mail
			this.tipoValor = 'email';
			this.condiciones = [{ VALOR: 3, TEXTO: '==' }];
			this.grupoVal.controls.valor.setValidators([Validators.required, Validators.email, Validators.maxLength(20)]);
		} else if (this.grupoVal.controls.criterio.value.TIPO == 5) {
			// Es fecha
			this.tipoValor = 'fecha';
			this.condiciones = [
				{ VALOR: 1, TEXTO: '<' },
				{ VALOR: 2, TEXTO: '<=' },
				{ VALOR: 3, TEXTO: '==' },
				{ VALOR: 4, TEXTO: '>' },
				{ VALOR: 5, TEXTO: '>=' },
			];
		}
	}

	add(event: MatChipInputEvent): void {
		const input = event.input;
		const value = event.value;

		// Add our emails
		if ((value || '').trim()) {
			this.correos.push(value.trim());
		}

		// Reset the input value
		if (input) {
			input.value = '';
		}
	}

	asignarCriterios() {
		let obj = {
			IDCAMPANA: this.localSave.get('campana'),
			CRITERIOS: this.Criterio_DATA
		}
		this.spinner.show();
		this.gateway.save('asignarcriterios', obj).then((check) => {
			
			if(check == 'ASIGNAR'){
				this.snackbar.open("El proceso de asignación, finalizara en breve.", 'Cerrar', {
							 		duration: 10000
							 	});

				setTimeout(()=>{ 
					this.spinner.hide();
					this.tabController.index = 6;
				}, 50000);
				

			}else{
				this.spinner.hide();
				this.tabController.index = 6;
			}
		});
	}

	remove(correo: any): void {
		const index = this.correos.indexOf(correo);

		if (index >= 0) {
			this.correos.splice(index, 1);
		}
	}

	getError(type) {
		if (type == 1) {
			if (this.grupoVal.controls.criterio.hasError('required')) {
				return 'Debes seleccionar un Criterio';
			}
		}
		if (type == 2) {
			if (this.grupoVal.controls.condicion.hasError('required')) {
				return 'Debes seleccionar una Condición';
			}
		}
		if (type == 3) {
			if (this.grupoVal.controls.valor.hasError('required')) {
				return 'Debes ingresar un Valor';
			}
		}
	}

	getErrorMessage(element) {
		if (element.hasError('required')) {
			return "Campo requerido";
		} else if (element.hasError('maxlength')) {
			return "Longitud maxima de " + element.errors.maxlength.requiredLength + " caracteres";
		} else {
			return "Error en el tipo de dato";
		}
		// } else if (element.hasError('maxlength')) {
		// 	return "Longitud maxima de " + element.errors.maxlength.requiredLength + " caracteres";
		// } else if (element.hasError('minlength')) {
		// 	return "Longitud mínima de " + element.errors.minlength.requiredLength + " caracteres";
		// } else if (element.hasError('matDatepickerMin')) {
		// 	return "La fecha debe ser mayor al dia de hoy";
		// }
	}
}

